import request from '@/utils/request'
import { ConstConfig, varConfig } from '@/utils'

export function getBMMatchTeams(params) {
  return request({
    url: ConstConfig.apiPath + '/AdminGetBMMatchTeams.json',
    method: 'get',
    params
  })
}

export function getBMMatchSignUpRule(params) {
  return request({
    url: ConstConfig.apiPath + '/GetBMMatchSignUpRule.json',
    method: 'get',
    params
  })
}

export function createBMTeam(data) {
  return request({
    url: ConstConfig.apiPath + '/CreateBMTeam.json',
    method: 'post',
    data
  })
}

export function updateBMMatchSignUpRule(params) {
  return request({
    url: ConstConfig.apiPath + '/UpdateBMMatchSignUpRule.json',
    method: 'get',
    params
  })
}

export function getBMPlayerList(params) {
  return request({
    url: ConstConfig.apiPath + '/GetBMPlayerList.json',
    method: 'get',
    params
  })
}

export function updateBMMatchTeamInfo(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateBMMatchTeamInfo.json',
    method: 'post',
    data
  })
}

export function getBMTeamDetailV2(params) {
  return request({
    url: ConstConfig.apiPath + '/GetBMTeamDetailV2.json',
    method: 'get',
    params
  })
}

export function getBMTeamInfo(params) {
  return request({
    url: ConstConfig.apiPath + '/GetBMTeamInfo.json',
    method: 'get',
    params
  })
}

export function updateBMMatchTeamRelations(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateBMMatchTeamRelations.json',
    method: 'post',
    data
  })
}

export function updateBMPlayer(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateBMPlayer.json',
    method: 'post',
    data
  })
}

export function updateBMMatchTeamAuditStatus(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateBMMatchTeamAuditStatus.json',
    method: 'post',
    data
  })
}

export function getBMTeamPlayerList(params) {
  return request({
    url: ConstConfig.apiPath + '/GetBMTeamPlayerList.json',
    method: 'get',
    params
  })
}

export function getMyManageBMMatchList(params) {
  return request({
    url: ConstConfig.apiPath + '/GetMyManageBMMatchList.json',
    method: 'get',
    params
  })
}

export function getBMTeamListByMatchId(params) {
  return request({
    url: ConstConfig.apiPath + '/GetBMTeamListByMatchId.json',
    method: 'get',
    params
  })
}

export function createBMMatchTeamInfo(data) {
  return request({
    url: ConstConfig.apiPath + '/CreateBMMatchTeamInfo.json',
    method: 'post',
    data
  })
}

export function getBMMatchTeamList(params) {
  return request({
    url: ConstConfig.apiPath + '/GetBMMatchTeamList.json',
    method: 'get',
    params
  })
}

export function getBMTeamListByUserId(params) {
  return request({
    url: ConstConfig.apiPath + '/GetBMTeamListByUserId.json',
    method: 'get',
    params
  })
}

export function applyJoinBMMatchTeam(data) {
  return request({
    url: ConstConfig.apiPath + '/ApplyJoinBMMatchTeam.json',
    method: 'post',
    data
  })
}

export function replaceBMMatchTeam(data) {
  return request({
    url: ConstConfig.apiPath + '/ReplaceBMMatchTeam.json',
    method: 'post',
    data
  })
}

export function getBMTeamUserList(params) {
  return request({
    url: ConstConfig.apiPath + '/GetBMTeamUserList.json',
    method: 'get',
    params
  })
}

export function createBMPlayerByUser(data) {
  return request({
    url: ConstConfig.apiPath + '/CreateBMPlayerByUser.json',
    method: 'post',
    data
  })
}

export function bmMatchOrganizationAddBMPlayer(data) {
  return request({
    url: ConstConfig.apiPath + '/BMMatchOrganizationAddBMPlayer.json',
    method: 'post',
    data
  })
}

export function deleteBMPlayer(data) {
  return request({
    url: ConstConfig.apiPath + '/DeleteBMPlayer.json',
    method: 'post',
    data
  })
}

export function addSelftBMPlayer(data) {
  return request({
    url: ConstConfig.apiPath + '/AddSelftBMPlayer.json',
    method: 'post',
    data
  })
}

export function getSelftBMPlayer(data) {
  return request({
    url: ConstConfig.apiPath + '/GetSelftBMPlayer.json',
    method: 'post',
    data
  })
}

export function getBMMatchGroupTeam(data) {
  return request({
    url: ConstConfig.apiPath + '/GetBMMatchGroupTeam.json',
    method: 'post',
    data
  })
}

export function updateBMMatchTeam(data) {
  return request({
    url: ConstConfig.apiPath + '/UpdateBMMatchTeam.json',
    method: 'post',
    data
  })
}

export function applyService(data) {
  return request({
    url: varConfig.cbApi + ConstConfig.apiPath + '/ApplyService.json',
    method: 'post',
    data
  })
}

export function getVerifyCode(data) {
  return request({
    url: varConfig.cbApi + ConstConfig.apiPath + '/GetVerifyCode.json',
    method: 'post',
    data
  })
}

export function getAreaTreeList(data) {
  return request({
    url: varConfig.cbApi + ConstConfig.apiPath + '/GetAreaTreeList.json',
    method: 'post',
    data
  })
}

export function getJerseyMapByType(sportType) {
  sportType = sportType || '足球'
  var jerseyMaps = [
    {name: 'icon_white.png', color: '#fff', code: 1},
    {name: 'icon_blue.png', color: '#237cc0', code: 2},
    {name: 'icon_red.png', color: '#e74135', code: 3},
    {name: 'icon_yellow.png', color: '#ffc500', code: 4},
    {name: 'icon_green.png', color: '#0ab768', code: 5},
    {name: 'icon_purple.png', color: '#6a4c92', code: 6},
    {name: 'icon_orange.png', color: '#ee7001', code: 7},
    {name: 'icon_black.png', color: '#232323', code: 8},
    {name: 'icon_pink.png', color: '#fc4481', code: 25},
    {name: 'icon_light_blue.png', color: '#65c5e4', code: 26},
    {name: 'icon_grass_green.png', color: '#e2fa16', code: 27}
  ]
  if (sportType === '篮球') {
    jerseyMaps = [
      {name: 'activity/basket_1.png', color: '#fff', code: 1},
      {name: 'activity/basket_2.png', color: '#237cc0', code: 2},
      {name: 'activity/basket_3.png', color: '#e74135', code: 3},
      {name: 'activity/basket_4.png', color: '#ffc500', code: 4},
      {name: 'activity/basket_5.png', color: '#0ab768', code: 5},
      {name: 'activity/basket_6.png', color: '#6a4c92', code: 6},
      {name: 'activity/basket_7.png', color: '#ee7001', code: 7},
      {name: 'activity/basket_8.png', color: '#232323', code: 8},
      {name: 'activity/basket_25.png', color: '#fc4481', code: 25},
      {name: 'activity/basket_26.png', color: '#65c5e4', code: 26},
      {name: 'activity/basket_27.png', color: '#e2fa16', code: 27}
    ]
  }
  return jerseyMaps
}

export function getBMMatchTeamOfficerList(params) {
  params.appVersion = ConstConfig.appVersion
  return request({
    url: ConstConfig.apiPath + '/GetBMMatchTeamOfficerList.json',
    method: 'get',
    params
  })
}

export function addOfficer(data) {
  return request({
    url: ConstConfig.apiPath + '/BMMatchOrganizationAddTeamOfficer.json',
    method: 'post',
    data
  })
}

export function updateOfficer(data) {
  return request({
    url: ConstConfig.apiPath + '/BMMatchOrganizationUpdateTeamOfficer.json',
    method: 'post',
    data
  })
}

export function getAssociationMatchPlayerSignupInfo(params) {
  return request({
    url: ConstConfig.apiPath + '/GetAssociationMatchPlayerSignupInfo.json',
    method: 'get',
    params
  })
}

export function getAssociationMatchPlayerSignupInfoByCertInfo(params) {
  return request({
    url: ConstConfig.apiPath + '/GetAssociationMatchPlayerSignupInfoByCertInfo.json',
    method: 'get',
    params
  })
}

export function associationPlayerSignupMatch(data) {
  return request({
    url: ConstConfig.apiPath + '/AssociationPlayerSignupMatch.json',
    method: 'post',
    data
  })
}

export function matchOrganizationDeleteTeamOfficer(params) {
  return request({
    url: ConstConfig.apiPath + '/BMMatchOrganizationDeleteTeamOfficer.json',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/team.js